// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/Lato-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/Lato-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/Lato-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/fonts/Lato-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../public/fonts/Lato-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../public/fonts/Lato-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../public/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../public/fonts/Lato-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../public/fonts/Lato-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype'); 
  font-weight: 900; 
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: 900; 
  font-style: italic;
}

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: 700; 
  font-style: italic;
}

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
  font-weight: 400; 
  font-style: italic;
}

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
  font-weight: 300; 
  font-style: normal;
}

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
  font-weight: 300; 
  font-style: italic;
}

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
  font-weight: 400; 
  font-style: normal;
}

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: 'Lato';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype');
  font-weight: 100; 
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/theme/fonts.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,+DAAgE;EAChE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+DAAsE;EACtE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+DAAqE;EACrE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+DAAiE;EACjE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+DAAgE;EAChE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+DAAsE;EACtE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+DAAkE;EAClE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+DAAqE;EACrE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["@font-face {\n  font-family: 'Lato';\n  src: url('../../public/fonts/Lato-Black.ttf') format('truetype'); \n  font-weight: 900; \n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Lato';\n  src: url('../../public/fonts/Lato-BlackItalic.ttf') format('truetype');\n  font-weight: 900; \n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Lato';\n  src: url('../../public/fonts/Lato-Bold.ttf') format('truetype');\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Lato';\n  src: url('../../public/fonts/Lato-BoldItalic.ttf') format('truetype');\n  font-weight: 700; \n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Lato';\n  src: url('../../public/fonts/Lato-Italic.ttf') format('truetype');\n  font-weight: 400; \n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Lato';\n  src: url('../../public/fonts/Lato-Light.ttf') format('truetype');\n  font-weight: 300; \n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Lato';\n  src: url('../../public/fonts/Lato-LightItalic.ttf') format('truetype');\n  font-weight: 300; \n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Lato';\n  src: url('../../public/fonts/Lato-Regular.ttf') format('truetype');\n  font-weight: 400; \n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Lato';\n  src: url('../../public/fonts/Lato-Thin.ttf') format('truetype');\n  font-weight: 100;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Lato';\n  src: url('../../public/fonts/Lato-ThinItalic.ttf') format('truetype');\n  font-weight: 100; \n  font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
